import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4hskdnvtg2: FaireBrandEntity = {
  token: "b_4hskdnvtg2",
  type: "brand",
  name: "Studio Akiyo",
  avatarUrl:
    "https://cdn.faire.com/fastly/3f844e3d14ccbb9f2dd1ed4f6560577d43649a362d2328322491ea53b3483ee6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8e6c24317fcf5713359bc919b150e5b3b67c64ea4d2d2cdc265e471157c5da48.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3f844e3d14ccbb9f2dd1ed4f6560577d43649a362d2328322491ea53b3483ee6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8e6c24317fcf5713359bc919b150e5b3b67c64ea4d2d2cdc265e471157c5da48.png",
  location: "Edmonton, AB, CAN",
  minimumOrderDollars: 115,
  rating: 5,
  reviewCount: 181,
  isTopShop: true,
  isInsider: false,
  description:
    "At Studio Akiyo, we create minimal, modern candles and home fragrances designed to bring a sense of calm to everyday spaces. Our collections pair soft, refined scents with a timeless aesthetic, thoughtfully crafted for those who are sensitive to strong fragrances and drawn to a more peaceful home.\n\nEach piece is handmade in small batches in our studio located in  Edmonton. From mixing and pouring to finishing, every product is carefully crafted by our small team of two. We pride ourselves on using clean, thoughtfully selected ingredients so you can feel confident in both quality and safety.\n\nOur work has been featured by CBC News, Le Journal de Montréal, and The Skimm'.\n\nBeing socially conscious is central to our brand. A portion of every order supports the Canadian Mental Health Association within our local Edmonton community, reflecting our commitment to well-being and mindful living. Thank you for being part of this incredible journey.\n\nHandmade Product Disclaimer; each piece is mixed and poured by hand in our studio. As part of the handmade process, slight variations such as small air bubbles, subtle color shifts or surface texture differences will naturally occur. These may appear anywhere on the product and are NOT considered imperfections. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.433Z",
    importedBy: "entity-db-cli",
  },
};
